// Imports for external libraries go here.
import React, { forwardRef } from 'react';
import clsx from 'clsx';

import { LegalTextAreaProps } from './LegalTextArea.types';
import { StyledLegalTextArea } from './LegalTextArea.styles';

export const LegalTextArea = forwardRef<HTMLTextAreaElement, LegalTextAreaProps>(
  (
    {
      textareaId,
      textareaName,
      textareaLabel,
      textareaLabelClassName,
      isError,
      errorMessage,
      errorMessageClassName,
      maxLength,
      className,
      innerClassName,
      placeholder,
      inputValue,
      getInputValue,
      disabled,
    },
    ref
  ) => {
    const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      getInputValue?.(event.target.value);
    };
    return (
      <StyledLegalTextArea
        data-component-name="m-legal-LegalTextArea"
        data-testid="legal-LegalTextArea"
        className={clsx('m-text-area', className, isError ? 'is-error' : 'is-active')}
      >
        <span id={`rfp-${textareaName}`}></span>
        <label htmlFor={textareaId}>
          <span className={textareaLabelClassName}>{textareaLabel}</span>
        </label>
        <textarea
          name={textareaName}
          id={textareaId}
          ref={ref}
          className={innerClassName}
          placeholder={placeholder}
          value={inputValue}
          onChange={onChange}
          maxLength={maxLength}
          disabled={disabled}
          aria-label={textareaLabel}
        ></textarea>
        {isError && <span className={clsx(errorMessageClassName, 'error-text t-font-xs')}>{errorMessage}</span>}
      </StyledLegalTextArea>
    );
  }
);
